const skillGroups = [
  {
    label: "AI & Agentic",
    items: [
      "MCP",
      "A2UI",
      "LangChain",
      "RAG pipelines",
      "Agent orchestration & evaluation",
      "Context engineering",
      "OpenAI/Claude/Gemini APIs",
    ],
  },
  {
    label: "Languages",
    items: ["Python", "TypeScript/JavaScript", "SQL", "HTML5", "CSS3"],
  },
  {
    label: "Frontend",
    items: [
      "Angular",
      "React",
      "Next.js",
      "Stencil (Web Components)",
      "RxJS",
      "Tailwind CSS",
    ],
  },
  {
    label: "Backend & Data",
    items: [
      "Node.js",
      "Express.js",
      "REST API design",
      "OAuth2/JWT",
      "PostgreSQL",
      "MongoDB",
      "Redis",
    ],
  },
  {
    label: "Cloud & DevOps",
    items: [
      "AWS (EC2, S3)",
      "Azure",
      "Docker",
      "Kubernetes",
      "CI/CD",
      "Git",
      "Observability",
    ],
  },
  {
    label: "Core CS",
    items: [
      "DSA",
      "System design",
      "OOP",
      "Unit & integration testing (Jest, Playwright)",
      "Agile/Scrum",
    ],
  },
];

export default skillGroups;
